import React from "react";
import ServicesDesktopView from "../desktopServices";
import WhyChooseUs from "../../../components/why-choose-us";
import { useMediaQuery, useTheme } from "@mui/material";
import ServicesMobileView from "../mobileServices";

const standardservices1 = [
  "HASSLE-FREE PICK/DROP",
  "COMPLETE DIAGNOSE AND SCANNING",
  "ENGINE OIL CHANGE",
  "OIL FILTER CHANGE",
  "AIR FILTER CHANGE",
  "AC CABIN FILTER CLEAN",
  "DIESEL/FUEL FILTER CLEAN",
  "COOLANT TOP UP",
  "BATTERY WATER TOP-UP",
];

const standardservices2 = [
  "WIPER FLUID TOP-UP",
  "BRAKE/CLUTCH FLUID TOP-UP",
  "FRONT & REAR BRAKES SERVICE",
  "SPARK PLUGS SERVICE",
  "SUSPENSION CHECK-UP",
  "INTERIOR VACUUM",
  "THROTTLE BODY WASH",
  "FREE VEHICLE DROP",
];

const periodicservices1 = [
  "HASSLE-FREE PICK/DROP",
  "COMPLETE DIAGNOSIS AND SCANNING",
  "ENGINE OIL CHANGE",
  "OIL FILTER CHANGE",
  "AIR FILTER CHANGE",
  "AC FILTER CHANGE",
  "DIESEL/FILTER CHANGE",
  "COOLANT TOP UP",
  "BATTERY TOP-UP",
  "WIPER FLUID TOP-UP",
];

const periodicservices2 = [
  "BRAKE/CLUTCH FLUID TOP-UP",
  "GEAR/TRANSMISSION OIL TOP UP",
  "FRONT& REAR BRAKE PAD SERVICE",
  "SPARK PLUGS SERVICE",
  "SUSPENSION CHECK-UP",
  "RADIATOR AIR WAND",
  "WHEEL ALIGNMENT AND BALANCING",
  "TIRE ROTATION",
  "INTERIOR VACUUM",
  "THROTTLE BODY WASH",
];

const AcServices = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      {/* <PricingList /> */}
      {isMobile ? (
        <>
        <ServicesMobileView
          title="Standard Services"
          serviceList1={standardservices1}
          serviceList2={standardservices2}
        />
        <ServicesMobileView
          title="Premium Services"
          serviceList1={standardservices1}
          serviceList2={standardservices2}
        />
        </>
      ) : (
        <>
          <ServicesDesktopView
            title="Standard Services"
            serviceList1={standardservices1}
            serviceList2={standardservices2}
          />
          <ServicesDesktopView
            title="Premium Services"
            serviceList1={periodicservices1}
            serviceList2={periodicservices2}
          />
        </>
      )}

      <WhyChooseUs />
      {/* <Stats /> */}
    </>
  );
};

export default AcServices;
